import { useCallback, useMemo } from 'react';
import { getWindow } from '../../../system/util/globals';
import { consoleWarn } from '../../../system/util/consoleWarn';
import { isFilterValueEmpty } from '../utils/isFilterValueEmpty';
var win = getWindow();
export var useFilterLocalStorage = function useFilterLocalStorage(filterId) {
  var setValue = useCallback(function (newValue) {
    if (!win) {
      return;
    }

    if (!filterId) {
      consoleWarn('You should submit the filterId parameter');
      return;
    }

    var localStorage = win.localStorage;
    var filterKey = "filter:".concat(filterId);

    if (isFilterValueEmpty(newValue)) {
      localStorage.removeItem(filterKey);
    } else {
      localStorage.setItem(filterKey, JSON.stringify(newValue));
    }
  }, [win, filterId]);
  var initialValue = useMemo(function () {
    if (!win) {
      return undefined;
    }

    var localStorage = win.localStorage;
    var result;
    var serializedValue = localStorage.getItem("filter:".concat(filterId));

    try {
      if (serializedValue) {
        result = JSON.parse(serializedValue);
      }
    } catch (error) {}

    return result;
  }, [win]);
  return [initialValue, setValue];
};